import { render, staticRenderFns } from "./HsabExpenseFormAddBankAccount.vue?vue&type=template&id=35d7b6b6&scoped=true"
import script from "./HsabExpenseFormAddBankAccount.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseFormAddBankAccount.vue?vue&type=script&lang=ts"
import style0 from "./HsabExpenseFormAddBankAccount.vue?vue&type=style&index=0&id=35d7b6b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7b6b6",
  null
  
)

export default component.exports